import styled from "styled-components/macro";

import { useGetCurrentSignupList } from "Utilities/Hooks/useGetCurrentSignupList";

import SignupOption from "../SignupOption";

export default function ShareWithOtherGroups() {
  const {
    options: { shared },
    signupListStatusID,
  } = useGetCurrentSignupList();

  return (
    <SignupOption
      text="Share this Signup with other groups in your network"
      name="shared"
      on={shared > 0}
      disabled={signupListStatusID !== 1}
    >
      <HelpText>
        When this box is checked, Group Admins and Note Senders will be able to
        view and edit this Signup. Super Admins will always be able to view and
        edit Signups regardless of this setting.
      </HelpText>
    </SignupOption>
  );
}
const HelpText = styled.div`
  font-size: 15px;
  color: #828c8d;
  box-sizing: border-box;
  font-weight: 400;
  max-width: 600px;
`;
